import Tween from 'tween';
import * as SUGA from 'suga';

/**
 * Game visualization of the data that model contains.
 */
export default class SpinButton extends PIXI.Container
{

    /**
     * Adds the eye button.
     *
     * @param  {String}  size           The size
     * @param  {String}  url            The url
     * @param  {String}  iconUrl        The icon url
     * @param  {String}  reflectionUrl  The reflection url
     * @param  {String}  font           The font
     */
    constructor(size, url, iconUrl, reflectionUrl, font, handler)
    {
        super()

        this.STOP_PERCENT = 0.90;

        this.buttonClick = handler;

        this.button = new PIXI.Sprite.fromImage(url);
        this.addChild(this.button);
        this.button.interactive = true;
        this.button.buttonMode = true;

        this.button.pointerup = (e) =>
        {
            this.click(e)
        };

        this.button.pointerupoutside = () =>
        {
            this.buttonPulse.scale.set(1);
        };

        const style = {
            fontFamily: font,
            fontSize: 20,
        };

        this.addButtonPulse()
        this.addText(this.getSpinText(),style)
        this.addIcon(iconUrl)
        this.addReflection(reflectionUrl)
    }

    addButtonPulse()
    {
        const textures = SUGA.Loader.makeTexturesFromName('button-pulse');
        this.buttonPulse = new PIXI.extras.AnimatedSprite(textures);
        this.button.addChild(this.buttonPulse);
        this.buttonPulse.anchor.set(0.5);
        this.buttonPulse.centerX();
        this.buttonPulse.centerY();
        this.buttonPulse.animationSpeed = 0.2;
        this.buttonPulse.play();
    }

    addText(text, style)
    {
        this.text = new PIXI.Text(text, style);
        this.button.addChild(this.text);
        this.text.centerX();
        this.text.centerY();
    }

    addIcon(iconUrl)
    {
        this.icon = new PIXI.Sprite.fromImage(iconUrl);
        this.button.addChild(this.icon);
        this.icon.anchor.set(0.5);
        this.icon.centerX();
        this.icon.centerY();
    }

    addReflection(reflectionUrl)
    {
        const reflection = new PIXI.Sprite.fromImage(reflectionUrl);
        this.button.addChild(reflection);
    }

    click(e)
    {
        SUGA.Sound.play('spin-button');

        this.buttonClick(e);
    }
    reset()
    {
        this.text.text = this.getSpinText()
        this.text.centerX()
    }

    showStopText(delay, isAuto)
    {

        if (isAuto)
        {
            this.text.text = this.getStopText()
            this.text.centerX()
            return
        }

        this.fadeTextOut();
        PIXI.setTimeout(delay, () =>
        {
            this.fadeTextIn(this.getStopText());
        });
    }

    showSpinText(delay, isAuto)
    {

        if (isAuto) return
        PIXI.setTimeout(delay, () =>
        {
            this.fadeTextIn(this.getSpinText());
        });
    }

    hideText(isAuto, cb)
    {

        if (isAuto)
        {
            if (cb)
            {
                cb();
            }
            return
        }
        this.fadeTextOut(cb);
    }

    /**
     * Set button text and fed it in
     *
     * @param  {String}    label    The label
     * @param  {Boolean}    disable  The disable
     * @param  {Function}  cb       Completion Handler
     */
    fadeTextIn(label, enable = true, cb)
    {
        this.text.text = label;
        this.text.centerX();

        const opts = {
            alpha: 1,
            onComplete: () =>
            {
                if (cb)
                {
                    cb();
                }
            },
        };

        Tween.to(this.text, 0.1, opts);
    }

    /**
     * Fade button text out
     *
     * @param  {Function}  cb     Completion Handler
     */
    fadeTextOut(cb)
    {
        if(this.isAutoplay)
        {
            if (cb)
            {
                cb();
            }
            return;
        }

        const opts = {
            alpha: 0,
            onComplete: () =>
            {
                if (cb)
                {
                    cb();
                }
            },
        };

        Tween.to(this.text, 0.1, opts);
    }


    /**
     * Spin the icon in the spin button
     *
     * @param  {Number}  degrees   The degrees
     * @param  {Number}  duration  The duration
     */
    spin(degrees, duration)
    {
        const opts = {
            rotation: window.degToRad(degrees),
            ease: window.Power1.easeInOut,
            onComplete: () =>
            {
                this.icon.rotation = 0;
                this.iconTween = null;
            },
        };

        this.iconTween = Tween.to(this.icon, duration, opts);
    }

    stopSpin()
    {
            if (this.iconTween)
        {
            this.iconTween.totalProgress(this.STOP_PERCENT);
        }
    }

    enable()
    {
        this.interactiveChildren = true;
    }

    disable()
    {
        this.interactiveChildren = false;
    }

    getSpinText()
    {
        return __t.str('Spin').toUpperCase()
    }

    getStopText()
    {
        return __t.str('Stop').toUpperCase()
    }
}


// WEBPACK FOOTER //
// ./themes/fq/view/spin-button.js